/**
 *
 * Asynchronously loads the component for Inventory
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
